module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av232-312af104a61b60bf4cc01e8f8ace0e6c.jpg";